import { useCreateHospital } from '_api';
import { HospitalPayload } from '_api/types';
import { SEVERITY } from '_constants/derived';
import { DefaultNewHospital } from '_constants/object-templates';
import { AlertMessage, BaseModal } from 'components/molecules';
import { HospitalForm } from 'components/organisms/forms';
import React, { useState } from 'react';

import { ModalProps } from './types';

export const AddHospital = ({ open, onClose }: ModalProps) => {
  const { mutateAsync: createHospital } = useCreateHospital();
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const onSubmit = (submitHospital: HospitalPayload) => {
    createHospital(submitHospital)
      .then((data) => {
        if (data && data.id) {
          setShowSuccess(true);
          setTimeout(() => onClose(), 1500);
        }
      })
      .catch(() => setShowError(true));
  };
  return (
    <BaseModal open={open} onClose={onClose} title={'Add Hospital/Clinic'}>
      <HospitalForm
        disableAll={showSuccess}
        initValue={DefaultNewHospital}
        onBack={onClose}
        onSubmit={onSubmit}
      />
      <AlertMessage
        open={showSuccess}
        onClose={() => setShowSuccess(false)}
        message={'Hospital Successfully created'}
      />
      <AlertMessage
        severity={SEVERITY.error}
        open={showError}
        onClose={() => setShowError(false)}
        message={'Failed to create Hospital. Resolve form issues and try again.'}
      />
    </BaseModal>
  );
};
